import React from 'react';
import { styles } from './ReservationStyles';

const ReservationTableRows = ({ data, onView, onEdit, onDelete, getStatusStyle }) => {
  return data.map((res) => (
    <tr key={res.id}>
      <td data-label="ID" style={styles.tableCell}>#{res.id}</td>
      <td data-label="Name" style={styles.tableCell}><strong>{res.name}</strong></td>
      <td data-label="Email" style={styles.tableCell}>{res.email}</td>
      <td data-label="Phone" style={styles.tableCell}>{res.phone}</td>
      <td data-label="Date" style={styles.tableCell}>{new Date(res.date).toLocaleDateString()}</td>
      <td data-label="Time" style={styles.tableCell}>{res.time}</td>
      <td data-label="Persons" style={styles.tableCell}>{res.persons}</td>
      <td data-label="Status" style={styles.tableCell}>
        <span style={{ ...styles.status, ...getStatusStyle(res.status) }}>
          {res.status}
        </span>
      </td>
      <td data-label="Submitted At" style={styles.tableCell}>{new Date(res.submittedAt).toLocaleDateString()}</td>
      <td data-label="Actions" style={styles.tableCell}>
        <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end' }}>
          <span style={styles.viewIcon} onClick={() => onView(res)}><i className="fas fa-eye"></i></span>
          <span style={styles.ellipsisIcon} onClick={() => onEdit(res)}><i className="fas fa-edit"></i></span>
          <span style={styles.deleteIcon} onClick={() => onDelete(res.id)}><i className="fas fa-trash"></i></span>
        </div>
      </td>
    </tr>
  ));
};

export default ReservationTableRows;